import { useEffect, useRef } from 'react';

// These values define the server-side population behind a flat treatment-row
// selection. Pagination and ordering are deliberately absent: selections can
// span pages and a sort only changes presentation, not membership.
const FLAT_SELECTION_SCOPE_KEYS = [
    'practiceId',
    'activePracticeIdsKey',
    'type',
    'filterStatus',
    'tableStatus',
    'searchValue',
    'searchQuery',
    'searchFilterTags',
    'treatmentData',
    'noTreatmentFilter',
    'startDate',
    'endDate',
    'contactCount',
    'contactedCountFilterValue',
    'checklistStateValue',
    'referral',
    'practices',
    'bookedWithData',
    'consultationBookedWithData',
    'assigneeData',
    'category',
    'depositPendingStatus',
    'archiveReason',
    'apptType',
    'bookedWidgetFilter',
    'activeFilterLabel',
    'currentWidget',
    'controlledCustomTabId',
    'selectedTab',
    'displayForCategorySummary',
    'leadCategoryType',
    'newLeadViewMode',
    'taskDueBucket',
];

export function buildFlatSelectionScopeKey(scope) {
    return JSON.stringify(
        FLAT_SELECTION_SCOPE_KEYS.reduce((result, key) => {
            result[key] = scope[key];
            return result;
        }, {})
    );
}

export default function useFlatSelectionScopeReset(scope, selectionRef, clearSelection) {
    const scopeKey = buildFlatSelectionScopeKey(scope);
    const previousScopeKeyRef = useRef(scopeKey);

    useEffect(() => {
        const scopeChanged = previousScopeKeyRef.current !== scopeKey;
        previousScopeKeyRef.current = scopeKey;
        const currentSelection = selectionRef.current;

        if (scopeChanged && currentSelection?.isFlatSelection && currentSelection?.leadId?.length) {
            clearSelection();
        }
    }, [clearSelection, scopeKey, selectionRef]);

    return scopeKey;
}
